// extracted by mini-css-extract-plugin
module.exports = {"searchButton":"SearchButton_searchButton__tniqx","searchButtonText":"SearchButton_searchButtonText__mVnuG","searchButtonDark":"SearchButton_searchButtonDark__Zp6rh"};